import React from 'react';

function ProgressBar(props) {
  const {skillName, skillLevel, skillLevelPercentage} = props;
  return (
    <div className='barContainer' style={{margin: "1% 0"}}>
      <div className='innerBar' style={{width: `${skillLevel}`}}>
      <p className='barText'>{skillName}</p>
      </div>
      <p className='barPercentage'>{skillLevelPercentage}</p>
    </div>
  );
}

export default ProgressBar;